import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Toast = ({ message, duration = 10, type = 'info', isVisible }) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration]);

  const getToastStyles = () => {
    switch(type) {
      case 'success':
        return {
          bg: 'bg-green-500',
          icon: 'fas fa-check-circle',
        };
      case 'error':
        return {
          bg: 'bg-red-500',
          icon: 'fas fa-exclamation-circle',
        };
      case 'warning':
        return {
          bg: 'bg-yellow-500',
          icon: 'fas fa-exclamation-triangle',
        };
      default:
        return {
          bg: 'bg-blue-500',
          icon: 'fas fa-info-circle',
        };
    }
  };

  const { bg, icon } = getToastStyles();

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50 }}
          className="fixed top-20 left-0 right-0 z-50 flex justify-center pointer-events-none"
        >
          <div className={`${bg} text-white px-4 py-3 rounded-md shadow-lg flex items-center max-w-sm mx-4`}>
            <i className={`${icon} mr-2`}></i>
            <span>{message}</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Toast;